









































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/SpaceWizards/SamplingSpaceWizard/WizardNavbar'
import WizardNavigation from '@ui/SpaceWizards/SamplingSpaceWizard/WizardNavigation'
import SamplingSpaceAvailabilityBindSelector from '@ui/ResourceBindSelector/SamplingSpaceAvailabilityBindSelector'
import Modal from '@components/Modal'

settings =
  name: 'AvailabilityStep'

  resources:
    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:wizard.supplierId/audience_availabilities'
      fetch: false
      params:
        quick_list: true

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      SamplingSpaceAvailabilityBindSelector,
      Modal,
    }

    data: ->
      missingAvailabilitiesModal:
        show: false
        stepName: null
      missingCapacityModal:
        show: false
        stepName: null

    computed:
      optionsForBindSelector: ->
        supplierId: @wizard.supplierId

      hasAvailabilities: ->
        @wizard.spaceData.availability_ids?.length > 0

      availabilitiesMissingCapacity: ->
        availabilities = (@availabilities || []).filter((av) => av.id in @wizard.spaceData.availability_ids)
        availabilities.filter((availability) =>
          @isEmptyValue availability.engagement_capacity?[@wizard.spaceData.segment]?.sampling_capacity
        )

      displayConfirmModal: ->
        return true unless @hasAvailabilities
        return true unless @availabilitiesMissingCapacity.length is 0
        false

    methods:
      hiConfirmModal: (stepName) ->
        if !@hasAvailabilities
          @missingAvailabilitiesModal.show = true
          @missingAvailabilitiesModal.stepName = stepName
          return

        if @availabilitiesMissingCapacity.length > 0
          @missingCapacityModal.show = true
          @missingCapacityModal.stepName = stepName
          return

export default VueOptions.vue settings
